"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKShell = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../common");
var components_1 = require("../../components");
var context_1 = require("../../components/GKAlert/context");
require("@granular/gds-ux-assets/ux-core.css");
require("./GKShell.css");
/** @deprecated in favor of GKLayoutShell */
var GKShell = function (props) {
    var _a = (0, common_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-shell",
    }), alertsOverlay = _a.alertsOverlay, children = _a.children, otherProps = __rest(_a, ["alertsOverlay", "children"]);
    var alertContainerClass = alertsOverlay
        ? "alerts-overlay"
        : "alerts-inline";
    return (React.createElement("div", __assign({}, otherProps),
        React.createElement(common_1.WindowSizeManager, null,
            React.createElement(context_1.GKAlertsManager, { global: true },
                React.createElement(common_1.OverlayManager, null,
                    React.createElement(components_1.GKContextualAlerts, { global: true, className: alertContainerClass }),
                    children)))));
};
exports.GKShell = GKShell;
exports.default = exports.GKShell;
